<template>
  <div class="pointer-events-none fixed right-4 top-4 z-[90] flex w-full max-w-sm flex-col gap-2">
    <div
      v-for="item in notifications"
      :key="item.id"
      class="pointer-events-auto rounded-xl border px-4 py-3 shadow-lg backdrop-blur"
      :class="notificationClass(item.type)"
    >
      <div class="flex items-start gap-3">
        <div class="min-w-0 flex-1">
          <div class="text-sm font-semibold">{{ item.title }}</div>
          <div v-if="item.message" class="mt-1 whitespace-pre-line text-xs opacity-90">{{ item.message }}</div>
        </div>
        <button
          type="button"
          class="rounded-md px-1 text-xs opacity-70 transition hover:opacity-100"
          @click="dismissNotification(item.id)"
        >
          x
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useNotifications } from '@/utils/notifications'

const { notifications, dismissNotification, notificationClass } = useNotifications()
</script>
